<template>
  <div class="item-detail-header" id="item-detail-print-area">
    <!-- 个体基本信息头部 -->
    <div class="header-top">
      <div class="header-left">
        <div class="vid-badge">
          <span class="vid-label">VID</span>
          <span class="vid-value">{{ itemData.vid || '-' }}</span>
        </div>
        <!-- 状态tag -->
        <span class="state-tag" :class="stateClass">{{ stateText }}</span>
      </div>
      <div class="header-right">
        <a-button size="small" @click="handlePrint">
          <a-icon type="printer" />打印详情
        </a-button>
        <a-button type="primary" size="small" @click="$emit('edit')">
          <a-icon type="edit" />编辑
        </a-button>
      </div>
    </div>
    
    <!-- 基本信息行 -->
    <div class="info-row">
      <div class="info-item">
        <span class="info-label">出生日期</span>
        <span class="info-value">{{ itemData.birth_date || '-' }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">性别</span>
        <span class="info-value">{{ genderText }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">RFID</span>
        <span class="info-value">{{ itemData.rf_id || '-' }}</span>
      </div>
    </div>
    
    <!-- 关键指标卡片 -->
    <div class="metrics-row">
      <div class="metric-card">
        <div class="metric-content">
          <div class="metric-value">{{ formatValue(latestBodyData.weight) }}</div>
          <div class="metric-label">体重(kg)</div>
        </div>
      </div>
      <div class="metric-card">
        <div class="metric-content">
          <div class="metric-value">{{ formatValue(latestBodyData.height) }}</div>
          <div class="metric-label">身高(cm)</div>
        </div>
      </div>
      <div class="metric-card">
        <div class="metric-content">
          <div class="metric-value health-status" :class="healthStatusClass">{{ healthStatusText }}</div>
          <div class="metric-label">健康状态</div>
        </div>
      </div>
      <div class="metric-card">
        <div class="metric-content">
          <div class="metric-value">{{ formatValue(itemData.gebv) }}</div>
          <div class="metric-label">GEBV</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemDetailHeader',
  props: {
    itemData: {
      type: Object,
      default: () => ({})
    },
    latestBodyData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    genderText() {
      if (this.itemData.gender === 1 || this.itemData.item_gender === 1) {
        return '公';
      } else if (this.itemData.gender === 0 || this.itemData.item_gender === 0) {
        return '母';
      }
      return '-';
    },
    // 健康状态（基于died_at）
    healthStatusText() {
      if (this.itemData.died_at) {
        return '已死亡';
      }
      return '健康';
    },
    healthStatusClass() {
      if (this.itemData.died_at) {
        return 'status-dead';
      }
      return 'status-healthy';
    },
    // 状态tag（基于state字段）
    stateText() {
      const state = this.itemData.state;
      switch (state) {
        case null:
        case undefined:
          return '已入库';
        case 1:
          return '候补';
        case 2:
          return '可用';
        case 3:
          return '不可用';
        default:
          return '已入库';
      }
    },
    stateClass() {
      const state = this.itemData.state;
      switch (state) {
        case null:
        case undefined:
          return 'state-stored';
        case 1:
          return 'state-backup';
        case 2:
          return 'state-active';
        case 3:
          return 'state-invalid';
        default:
          return 'state-stored';
      }
    }
  },
  methods: {
    formatValue(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      return value;
    },
    handlePrint() {
      // 隐藏不需要打印的元素
      const sidebar = document.querySelector('.ant-layout-sider');
      const header = document.querySelector('.ant-layout-header');
      const pageHeader = document.querySelector('.ant-page-header');
      
      // 添加打印类
      document.body.classList.add('printing-item-detail');
      
      // 触发打印
      window.print();
      
      // 打印完成后移除打印类
      setTimeout(() => {
        document.body.classList.remove('printing-item-detail');
      }, 100);
    }
  }
}
</script>

<style scoped>
.item-detail-header {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.vid-badge {
  display: flex;
  align-items: center;
  gap: 8px;
}

.vid-label {
  background: #2563EB;
  color: #fff;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.vid-value {
  font-size: 18px;
  font-weight: 600;
  color: #262626;
}

/* 状态tag样式 */
.state-tag {
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.state-stored {
  background: #e6f7ff;
  color: #1890ff;
  border: 1px solid #91d5ff;
}

.state-backup {
  background: #fff7e6;
  color: #fa8c16;
  border: 1px solid #ffd591;
}

.state-active {
  background: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}

.state-invalid {
  background: #fff1f0;
  color: #ff4d4f;
  border: 1px solid #ffa39e;
}

.header-right {
  display: flex;
  gap: 8px;
}

.info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 20px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-label {
  color: #8c8c8c;
  font-size: 14px;
}

.info-value {
  color: #262626;
  font-size: 14px;
  font-weight: 500;
}

.status-healthy {
  color: #52c41a;
}

.status-dead {
  color: #ff4d4f;
}

.metrics-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.metric-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
  text-align: center;
}

.metric-card:hover {
  border-color: #2563EB;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
}

.metric-content {
  width: 100%;
}

.metric-value {
  font-size: 20px;
  font-weight: 700;
  color: #262626;
  line-height: 1.2;
}

.metric-value.health-status {
  font-size: 16px;
}

.metric-label {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 4px;
}

@media (max-width: 768px) {
  .metrics-row {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .info-row {
    flex-direction: column;
    gap: 12px;
  }
  
  .header-left {
    flex-wrap: wrap;
  }
}

/* 打印样式 */
@media print {
  /* 隐藏侧边栏和头部 */
  .ant-layout-sider,
  .ant-layout-header,
  .ant-page-header,
  .no-print {
    display: none !important;
  }
  
  /* 打印时调整布局 */
  .ant-layout-content {
    margin: 0 !important;
    padding: 20px !important;
  }
  
  /* 确保打印区域可见 */
  .item-detail-header {
    box-shadow: none !important;
    border: 1px solid #e8e8e8 !important;
  }
  
  /* 打印时隐藏按钮 */
  .header-right {
    display: none !important;
  }
}
</style>

<!-- 全局打印样式 -->
<style>
/* 打印模式下的全局样式 */
body.printing-item-detail .ant-layout-sider,
body.printing-item-detail .ant-layout-header,
body.printing-item-detail .ant-page-header {
  display: none !important;
}

body.printing-item-detail .ant-layout-content {
  margin: 0 !important;
  padding: 20px !important;
  width: 100% !important;
}

body.printing-item-detail .ant-layout {
  display: block !important;
}

body.printing-item-detail .ant-layout-content {
  display: block !important;
}

/* 打印时强制颜色鲜艳 - 防止PDF颜色变淡 */
body.printing-item-detail {
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
  color-adjust: exact !important;
  background: #fff !important;
}

/* 强制所有容器背景为白色 - 覆盖任何灰色背景 */
body.printing-item-detail,
body.printing-item-detail *,
body.printing-item-detail .dashboard-bar-chart,
body.printing-item-detail .ant-card,
body.printing-item-detail .ant-card-body,
body.printing-item-detail .ant-card-head,
body.printing-item-detail .item-detail-header,
body.printing-item-detail .pedigree-tree,
body.printing-item-detail .pedigree-level,
body.printing-item-detail .pedigree-card,
body.printing-item-detail .card-header,
body.printing-item-detail .card-body,
body.printing-item-detail .parents-container,
body.printing-item-detail .grandparents-container,
body.printing-item-detail .grandparent-group,
body.printing-item-detail .grandparent-cards,
body.printing-item-detail .level-current,
body.printing-item-detail .level-parents,
body.printing-item-detail .level-grandparents {
  background: #fff !important;
  background-color: #fff !important;
}

body.printing-item-detail * {
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
  color-adjust: exact !important;
}

/* 打印时强制文字颜色为深色，提高对比度 */
body.printing-item-detail .vid-text,
body.printing-item-detail .info-value {
  color: #000 !important;
}

body.printing-item-detail .info-label,
body.printing-item-detail .level-label,
body.printing-item-detail .group-label {
  color: #333 !important;
}

body.printing-item-detail .gebv-label {
  color: #555 !important;
}

body.printing-item-detail .gebv-value {
  color: #1890ff !important;
  font-weight: 700 !important;
}

body.printing-item-detail .relation-tag {
  color: #666 !important;
  background: #f0f0f0 !important;
}

/* 打印时强制边框颜色更明显 */
body.printing-item-detail .pedigree-card {
  border: 1px solid #ccc !important;
  box-shadow: none !important;
}

body.printing-item-detail .card-header {
  border-bottom: 1px solid #ddd !important;
  background: #f8f8f8 !important;
}

body.printing-item-detail .gebv-section {
  border-top: 1px dashed #ccc !important;
}

/* 打印时性别图标颜色鲜艳 */
body.printing-item-detail .gender-icon.male {
  background: #d6e4ff !important;
  color: #1890ff !important;
}

body.printing-item-detail .gender-icon.female {
  background: #ffd6e7 !important;
  color: #eb2f96 !important;
}

/* 打印时卡片左边框颜色 */
body.printing-item-detail .pedigree-card.card-male {
  border-left: 3px solid #1890ff !important;
}

body.printing-item-detail .pedigree-card.card-female {
  border-left: 3px solid #eb2f96 !important;
}

/* 打印时隐藏个体谱系大图 */
body.printing-item-detail .modern-chart-container {
  display: none !important;
}

/* 打印时隐藏操作按钮和交互元素 */
body.printing-item-detail .ant-btn,
body.printing-item-detail .ant-tabs-nav,
body.printing-item-detail .heatmap-controls,
body.printing-item-detail .ant-pagination {
  display: none !important;
}

/* 打印时完全隐藏个体谱系卡片（包括header） */
body.printing-item-detail .pedigree-section-card {
  display: none !important;
}

/* 打印时隐藏亲属关系卡片的外框 */
body.printing-item-detail .family-relation-card {
  border: none !important;
  box-shadow: none !important;
}

body.printing-item-detail .family-relation-card .ant-card-head {
  border-bottom: none !important;
}

/* 打印时隐藏子代个体列表和时间线 */
body.printing-item-detail .item-timeline-section,
body.printing-item-detail .child-items-card,
body.printing-item-detail .biao-xing-section,
body.printing-item-detail .production-section {
  display: none !important;
}

/* 打印时亲属关系布局 */
body.printing-item-detail .pedigree-tree {
  padding: 8px !important;
}

body.printing-item-detail .level-label {
  margin-bottom: 8px !important;
}

/* 打印时父代布局 - 两个块放到一行 */
body.printing-item-detail .parents-container {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  gap: 16px !important;
  justify-content: space-between !important;
  margin-top: 8px !important;
}

body.printing-item-detail .parent-branch {
  flex: 0 0 48% !important;
  max-width: 48% !important;
  min-width: 0 !important;
  width: 48% !important;
}

/* 打印时祖代布局 - 父系母系放到一排 */
body.printing-item-detail .grandparents-container {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  gap: 16px !important;
  justify-content: space-between !important;
  margin-top: 12px !important;
}

body.printing-item-detail .grandparent-group {
  flex: 0 0 48% !important;
  max-width: 48% !important;
  min-width: 0 !important;
  width: 48% !important;
}

body.printing-item-detail .grandparent-cards {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  gap: 8px !important;
  justify-content: space-between !important;
}

body.printing-item-detail .grandparent-cards .pedigree-card {
  flex: 1 1 45% !important;
  max-width: 48% !important;
  min-width: 0 !important;
}

/* 打印时个体详情头部颜色 */
body.printing-item-detail .item-detail-header {
  box-shadow: none !important;
  border: 1px solid #ddd !important;
}

body.printing-item-detail .header-top {
  border-bottom: 1px solid #ddd !important;
}

body.printing-item-detail .vid-label {
  background: #2563EB !important;
  color: #fff !important;
}

body.printing-item-detail .vid-value {
  color: #000 !important;
}

body.printing-item-detail .state-tag {
  border: 1px solid !important;
}

body.printing-item-detail .state-stored {
  background: #e6f7ff !important;
  color: #1890ff !important;
  border-color: #91d5ff !important;
}

body.printing-item-detail .state-backup {
  background: #fff7e6 !important;
  color: #fa8c16 !important;
  border-color: #ffd591 !important;
}

body.printing-item-detail .state-active {
  background: #f6ffed !important;
  color: #52c41a !important;
  border-color: #b7eb8f !important;
}

body.printing-item-detail .state-invalid {
  background: #fff1f0 !important;
  color: #ff4d4f !important;
  border-color: #ffa39e !important;
}

body.printing-item-detail .metric-card {
  border: 1px solid #ddd !important;
  box-shadow: none !important;
}

body.printing-item-detail .metric-value {
  color: #000 !important;
}

body.printing-item-detail .metric-label {
  color: #333 !important;
}

body.printing-item-detail .status-healthy {
  color: #52c41a !important;
}

body.printing-item-detail .status-dead {
  color: #ff4d4f !important;
}
</style>
